import { createValidator } from "../../utils/validation";
import { transactionSchema } from "../validationRules/validateTransactionForm";
import { saleTrasactionTypeSchema } from "../validationRules/validateTransactionForm";
import { PurchaseTrasactionTypeSchema } from "../validationRules/validateTransactionForm";
import { LettingTrasactionTypeSchema } from "../validationRules/validateTransactionForm";

export const useValidateTransaction = () => {
    const validateTransaction = (formData) => {

        let customValidator = { ...transactionSchema };

        if (formData.transactionType === "Sale") {
            customValidator = { ...customValidator, ...saleTrasactionTypeSchema };
        }

        if (formData.transactionType === "Purchase") {
            customValidator = { ...customValidator, ...PurchaseTrasactionTypeSchema };
        }

        if (formData.transactionType === "Letting") {
            customValidator = { ...customValidator, ...LettingTrasactionTypeSchema };
        }

        const validator = createValidator(customValidator);

        return validator(formData);

    }

    return { validateTransaction }
}

